module.exports = __webpack_public_path__ + "img/logo.34b8fbb7.png";